console.log("Celluma - 1.2.1");
function sendMail() {
    var str = document.getElementById('productdetails').textContent;
    var strcut = str.substring(0, 1000);
    var prodname = document.getElementById('productname').textContent;


    var link = "mailto:yourfriend@email.com"
        + "?subject=" + escape(prodname)
        + "&body=" + escape(strcut) + "...";
    window.open(link, '_blank', 'width=600,height=600');
}

jQuery(window).load(function () {
    $(".product-info .price,.product-info  .total-price ").each(function () {
        var text = $(this).text().replace("$", "<sup>$</sup>");
        $(this).html(text);
    });
  
  
  
   
  
  

    AOS.init({
        offset: 50,
        duration: 800,
        easing: 'ease-out',
        once: true,
        delay: 0
    });
  
   if ( $("#mc_embed_signup").length ) {}else{
      $('body').css('margin-bottom','0px');
    }
  
  
  
    
  if ( $("#prodcarousel").length ) {
    var $frame  = $('#prodcarousel .car');
    var $slidee = $frame.children('.frame').eq(0);
    var $wrap   = $frame.parent();

    // Call Sly on frame
    $frame.sly({
      horizontal: 1,
      itemNav: 'basic',
      smart: 1,
      mouseDragging: 1,
      touchDragging: 1,
      releaseSwing: 1,
      scrollBar: $wrap.find('.scrollbar'),
      scrollSource: null, 
      scrollBy: 0, // Mousewheel scroll Off / On
      activatePageOn: 'click',
      speed: 500,
      elasticBounds: 1,
      easing: 'easeOutExpo',
      dragHandle: 1,
      dynamicHandle: 1,
      clickBar: 1,

      // Buttons
      prevPage: $wrap.find('.prev'),
      nextPage: $wrap.find('.next')
    });
	$frame.sly('reload');
    $(window).resize(function(e) {
      $frame.sly('reload');
    });


  }
  
  
  
  
  function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  
  
     var contact_posted = getParameterByName('contact_posted'); 
    if (contact_posted) {

		$('.dykv2thanks').show();
    }
  
  
  var test = getParameterByName('test'); 
  if (test == 1) {
    $('.withtest').show();
    $('.withouttest').hide();
    
    
  }
  
  if (test == 2) {
    $('.withtest2').addClass('showed');
    $('.withouttest2').hide();
    
     $('.withtest2flex').addClass('showed');
    
    
    
  
    
  }
  
  if (test == 3) {
    $('.withtest.save100').addClass('showing');
    $('.withtest.offerdiv').addClass('showing');
    $('.withtest.origprice').addClass('showing');
    
  }
  
  
  
});


function param(name) {
    return (location.search.split(new RegExp('[?&]' + name + '='))[1] || '').split('&')[0]; 
}

$(document).ready(function () {
  
  
  
  
  
	 if ( $("#nav li#menu-learn").length ) {

      var _nav = $("#nav li#menu-learn");
      var _nav_offset = _nav.offset();
      var _nav_height = _nav.outerHeight();
      var wST = $(window).scrollTop();

      $("#nav li#menu-learn").mouseenter(function() {
          $('.submen').stop().slideDown();
          $("#newheader").addClass('activesubmenu');
      });
      
      $(".submen .inner").mouseleave(function() {
        if(!$('.submen .inner').is(':hover')){
          setTimeout(
          function() 
          {
          	$('.submen').fadeOut('fast');
           	$("#newheader").removeClass('activesubmenu');
           }, 500);
        };
      });
     }
  
  
  
  $(document).on('click','#hamburger-icon', function(el){
		el.preventDefault();
		$(this).toggleClass('active');
		$('body').toggleClass('flyout-open');
    	$('html').toggleClass('flyout-open');
		
     	setTimeout(
          function() 
          {
   		 	$('#flyoutmenu .left .menu1, #flyoutmenu .left .menu2,#flyoutmenu .right .top, #flyoutmenu .right .middle, #flyoutmenu .right .bottom').fadeIn('slow');
          }, 300);
    
	})
  
  $(document).on('click','#hamburger-icon.active', function(el){
    setTimeout(
          function() 
          {
   $('#flyoutmenu .left .menu1, #flyoutmenu .left .menu2,#flyoutmenu .right .top, #flyoutmenu .right .middle, #flyoutmenu .right .bottom').hide();
            }, 400);
    
    
  })
  

  if ( $("#accord .accord").length ) {
    $("#accord .accord").accordionjs({
      activeIndex : 999,     
      closeAble: true, 
      closeOther  : true,  
      slideSpeed: 200 
    });
  }
   if ( $("#newhero").length ) {
  $("#newhero .whatit a").click(function (event) {
    event.preventDefault();
    	$("html, body").animate({ scrollTop: $('.inHome .buckets').offset().top}, 1500);
  });
      }
  

  

  
    if ( $("#testims .testimslider").length ) {
        $('#testims .testimslider').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
           fade: true,
		  cssEase: 'linear'
      });
    }
  
  
   
  
  
  
  
  

  
   $(".techs a").on('click', function() {

  
      $.fancybox.open({
        src  : '#fullspecs',
        type : 'inline',
        touch: false,
         helpers: {
          overlay: {
            locked: false
          }
        }
      });

    });
  
  
    $("#hero.professionalhero .btn2, #clinical.v2 .btn2, #block7 .btn2, #reseller .btn, #comparisonsect .btn2, #block13 .btn2").on('click', function() {

  
      $.fancybox.open({
        src  : '#specialpricepopup',
        type : 'inline',
        touch: false,
         helpers: {
          overlay: {
            locked: false
          }
        }
      });
      return false;

    });
  
  
  if ( $(".fancybox.videobox").length ) {
      $(".fancybox.videobox").fancybox({
          width:1000,
          height:560,
          autoDimensions: false
      })
  }
  
  
  if ( $('#anchorblock').length > 0 ) {
    $('#anchorblock a').click(function(){
      var target=$(this).attr('data-id');
       $("html, body").animate({scrollTop: $('h3#'+target).offset().top - 150}, 500);
      return false;
      
    });  
    
  }
  
  
  
  if ( $('#salepopup').length > 0 ) {
  
  
  //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup
  if( getCookie('salecookie') != 'submited'){ 
    if(getCookie('salecookie') != 'closed' ){
      setTimeout(
  function() 
  {
      $('#salepopup').css("display", "block").hide().fadeIn();
    }, 5000);
    }
  }
  
  $('#salepopup .close, #salepopup a, #salepopup .overlay').click(function(){
    $('#salepopup').fadeOut();
    //sets the coookie to one minute if the popup is closed (whole numbers = days)
    setCookie( 'salecookie', 'closed', 1 );
  });

    
  }
  
  
  
  
  
  
   
 
  
  
  
  

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  
  
  
  /* $('body').addClass('withpurplebar');*/
  

  
   if ( $('.purplebar').length > 0 ) {
     

        if(getCookie('purplebarcookie') != 'closed' ){
          $('.purplebar').css("display", "block").hide().fadeIn();
           $('main').addClass('withpurplebar');
        } else {
          
           $('body').removeClass('withpurplebar');
        }


      $('.purplebar .clos').click(function(){
        $('.purplebar').fadeOut().remove();
        setCookie( 'purplebarcookie', 'closed', 1 );
        $('body').removeClass('withpurplebar');
      });


    }
  
  
  
    
    $(".dmenu.forshop").appendTo('.site-header-inner .main-nav li:first-child');
    $(".dmenu.whatit").appendTo('.site-header-inner .main-nav li:nth-child(2)');
    $(".site-header-inner .main-nav li:first-child").addClass('withsub');
    $(".site-header-inner .main-nav li:nth-child(2)").addClass('withsub');

    $(".site-header-inner a.menu ").click(function () {
        $('.submm').slideDown();
    });

    $(".closeic").click(function () {
        $('.submm').slideUp();
    });

    $(".totop").click(function () {
        $("html, body").animate({scrollTop: 0}, 1000);
    });

    $(".template-index .herotext a.button").click(function () {
        $("html, body").animate({scrollTop: $('.hpblock2').offset().top - 50}, 1000);
    });

  var s = skrollr.init({
	
  });
    setTimeout(
        function () {
            s.refresh();
        }, 500);
    $(window).resize(function () {
        setTimeout(
            function () {
                s.refresh();
                $.fn.matchHeight._update()
            }, 500);
    });
    if ($("#productname").length) {
        $("#productname").html(
            $("#productname").html().replace("™", "<span class='tradem'>™</span>")
        );
    }
    $(".mega-box .protitle").each(function () {
        var productname = jQuery(this).text();
        $(this).next().find('a.product-item-name').text(productname);
    });
    if (!(/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i).test(navigator.userAgent || navigator.vendor || window.opera)) {
        var s = skrollr.init({
            forceHeight: false,
            easing: 'swing',
          
        });
 
    }

    $('.fullbanner .cntn').matchHeight({});
    $('body').matchHeight({
        remove: true
    });

    $('.maincontent .contleft').imagesLoaded(function () {
        $('.maincontent .contleft .bo').matchHeight({});
    });
    $('.maincontent .contright').imagesLoaded(function () {
        $('.maincontent .contright .bo').matchHeight({});
    });

    $('.videoslide').slick({
        dots: true,
        arrows: false,
        fade: true,
        infinite: true,
        autoplay: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        autoplaySpeed: 4000,
        pauseOnFocus: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    // Home page text slider
    $('.left .sliders').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        arrows: false,
        dots: true,
        pauseOnHover: false,
        pauseOnDotHover: false,
        pauseOnFocus: false
    });

    // For professionals slider
    $('#points').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        dots: false
    });

    $('.tab1').click(function (e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        $('.slider').slick('slickGoTo', 1);
    });

    $('.tab2').click(function (e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        $('.slider').slick('slickGoTo', 2);
    });

    $('.tab3').click(function (e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        $('.slider').slick('slickGoTo', 3);
    });

    /**
     * Home Page Tooltip Functionality
     */
    $(".left .tooltip").on('click', function () {
        var notice = $(".left .notice");
        if (notice.hasClass('on')) {
            notice.removeClass('on');
        } else {
            notice.addClass('on');
        }
    });
  
  
    // Click off
    $(document).on('click', '.template-index', function (event) {
        var classes = event.target;
        if (classes.className === '') {
            classes = classes.parentNode();
        }
        if (classes.className.indexOf('tooltip') && classes.className.indexOf('tooltiptext')) {
            if ($('.left .notice.on').length) {
                $('.left .notice').removeClass('on');
            }
        } else { /** **/
        }
    });
  
  
  
    if ($(window).width() < 542) {
  $(document).on('click', '#mc_embed_signup span', function (event) {
    event.preventDefault();
     $('#mc_embed_signup').toggleClass('opened');
   });
  }

    $(".site-header-inner .hamburger-container").click(function () {
        $('.hamburger-menu').toggleClass("animate");
        $(".site-header-inner .hamburger-container").toggleClass("animate");
        if ($('.hamburger-menu').hasClass('animate')) {
            $('.submm').slideDown();
            $("body").addClass('lock');
        } else {
            $('.submm').slideUp();
            $("body").removeClass('lock');
        }
    });
    // Secondary Close
    $(".submm .close").click(function() {
       $(".hamburger-menu").toggleClass('animate');
        $(".site-header-inner .hamburger-container").toggleClass("animate");
        if ($('.site-header-inner .hamburger-menu').hasClass('animate')) {
            $('.submm').slideDown();
            $("body").addClass('lock');
        } else {
            $('.submm').slideUp();
            $("body").removeClass('lock');
        }
    });

    /**
     * FAQ PAGE
     * Expand questions on click
     */
    $(".questions .label").on('click', function () {
        var parent = $(this).parent();
        if (parent.hasClass('active')) {
            parent.removeClass('active');
            $(this).find('.tool').html('+');
            parent.find('.answer').slideUp('fast', function () {
            });
        } else {
            parent.addClass('active');
            $(this).find('.tool').html('-');
            parent.find('.answer').slideDown('fast', function () {
            });
        }
    });

    /**
     * Expand quotes on click
     */
    $(".timeline .item .tool.more").on('click', function () {
        var parent = $(this).parent().parent();
        if (parent.hasClass('active')) {
            parent.removeClass('active');
            $(this).html('+');
            parent.find('.quote p .dots').css('display', 'inline');
            parent.find('.quote .more').slideUp('fast', function () {
            });
        } else {
            parent.addClass('active');
            $(this).html('-');
            parent.find('.quote p .dots').css('display', 'none');
            parent.find('.quote .more').slideDown('fast', function () {
                $(this).css('display', 'inline');
            });
        }
    });

    /**
     * ADVISORY BOARD PAGE
     * Open content modal on image or arrow click
     */
    $(".advisory .member .open, .advisory .member img").on('click', function () {
        var photo = $(this).parent().find('img').attr('src');
        var name = $(this).parent().find('h3').html();
        var position = $(this).parent().find('h4').html();
        var bio = $(this).parent().find('.bio').html();
        var popup = $(".advisory-popup");
        popup.addClass('active');
        $("body").addClass('lock');
        popup.find('.name').html(name);
        popup.find('.position').html(position);
        popup.find('.bio').html(bio);
        popup.find('.image').html('<img src="' + photo + '">');
    });
    // Close popup
    $(document).on('click', '.advisory-popup .content .green .close span', function () {
        $(".advisory-popup").removeClass('active');
        $("body").removeClass('lock');
    });

    /**
     * FOR PROFESSIONALS PAGE
     * Clinical Research tab switch
     */
    $(document).on('click', '#clinical .sections .section', function () {
        var dataid = $(this).attr('data-id');
        $('#clinical .sections .section').each(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
        });
        $(this).addClass('active');
        console.log(dataid);
        $('#clinical #section .section').each(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
        });
        $('#clinical #section .section[data-id="' + dataid + '"]').addClass('active');
    });

    // Product page image slider
    $('.product-single .sliders').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false
    });

    // Open reviews if clicking top review link
    if ($('.product-single').length) {
        $("#writeReview").on('click', function () {
            $("ul.tabs li:nth-child(2)").click();
            $(".spr-summary-actions-newreview").click();
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".tab-wrap").offset().top
            }, 1000);
        });
    }

    /**
     * RESULTS PAGE
     *
     * Main functionality
     */
    if ($(".results").length) {
        // Change link active state
        $(".categories a").on('click', function () {
            var id = $(this).attr('data-rel');
            $('.categories a').each(function () {
                $(this).removeClass('active');
            });
            $(this).addClass('active');
            // Change result container active state
            $('.results .result').each(function () {
                $(this).removeClass('active');
            });
            $('.results .result[data-rel="' + id + '"]').addClass('active');
            $('.results .result[data-rel="' + id + '"] .sliders').slick("refresh");
            // Change timeline active state
            $(".results .timelines .timeline").each(function () {
                $(this).removeClass('active');
            });
            $('.results .timelines .timeline[data-rel="' + id + '"]').addClass('active');
        });
        // More/Fewer Results
        $(".results .btn").on('click', function () {
            var id = $(this).parent().parent().attr('data-rel');
            if ($(this).hasClass('no')) {
                $(this).removeClass('no').addClass('yes');
                $(this).text('Fewer Results');
                $(".result[data-rel='" + id + "'] .item").each(function () {
                    if ($(this).hasClass('hidden')) {
                        $(this).removeClass('hidden');
                    }
                });
                $(this).parent().parent().find('.sliders').slick("refresh");
            } else {
                $(this).removeClass('yes').addClass('no');
                $(this).text('More Results');
                var x = 1;
                $(".result[data-rel='" + id + "'] .item").each(function () {
                    if (x > 3) {
                        $(this).addClass('hidden');
                    }
                    x++;
                });
            }
        });
        var location = window.location.href;
        if(location.includes('#aging')){
            $('.categories a').each(function () {
                $(this).removeClass('active');
            });
            $(".categories a[data-rel='1']").addClass('active');
            $('.results .result').each(function () {
                $(this).removeClass('active');
            });
            $('.results .result[data-rel="1"]').addClass('active');
            $('.results .result[data-rel="1"] .sliders').slick("refresh");
            // Change timeline active state
            $(".results .timelines .timeline").each(function () {
                $(this).removeClass('active');
            });
            $('.results .timelines .timeline[data-rel="1"]').addClass('active');
        }
        if(location.includes('#pain')){
            $('.categories a').each(function () {
                $(this).removeClass('active');
            });
            $(".categories a[data-rel='2']").addClass('active');
            $('.results .result').each(function () {
                $(this).removeClass('active');
            });
            $('.results .result[data-rel="2"]').addClass('active');
            $('.results .result[data-rel="2"] .sliders').slick("refresh");
            // Change timeline active state
            $(".results .timelines .timeline").each(function () {
                $(this).removeClass('active');
            });
            $('.results .timelines .timeline[data-rel="2"]').addClass('active');
        }
        if(location.includes('#acne')){
            $('.categories a').each(function () {
                $(this).removeClass('active');
            });
            $(".categories a[data-rel='3']").addClass('active');
            $('.results .result').each(function () {
                $(this).removeClass('active');
            });
            $('.results .result[data-rel="3"]').addClass('active');
            $('.results .result[data-rel="3"] .sliders').slick("refresh");
            // Change timeline active state
            $(".results .timelines .timeline").each(function () {
                $(this).removeClass('active');
            });
            $('.results .timelines .timeline[data-rel="3"]').addClass('active');
        }
        if(location.includes('#wound')){
            $('.categories a').each(function () {
                $(this).removeClass('active');
            });
            $(".categories a[data-rel='4']").addClass('active');
            $('.results .result').each(function () {
                $(this).removeClass('active');
            });
            $('.results .result[data-rel="4"]').addClass('active');
            $('.results .result[data-rel="4"] .sliders').slick("refresh");
            // Change timeline active state
            $(".results .timelines .timeline").each(function () {
                $(this).removeClass('active');
            });
            $('.results .timelines .timeline[data-rel="4"]').addClass('active');
        }
    }
	/*
    // Change Left side states
    $(document).on("click", ".page-layer .left .bottom .button", function () {
        var id = $(this).attr('data-id');
        if ($(this).hasClass('active')) {
            //
        } else {
            $(".page-layer .left .bottom .button").each(function () {
                $(this).removeClass('active');
            });
            $(this).addClass('active');
            $(".page-layer .left .top .item").each(function () {
                $(this).removeClass('active');
            });
            $(".page-layer .left .top .item[data-id='" + id + "']").addClass('active');
            $(".page-layer .left .top .bas").slick("refresh");
        }
    });
    */
    // Left before/after image slider
    $('.page-layer .bas').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: true,
        mobileFirst: true
    });
    // Right image slider
    $('.page-layer .sliders').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: true,
        mobileFirst: true
    });
    // Middle quotes slider
    $('.page-layer .quotes').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true,
        mobileFirst: true
    });
	
  // Generic quotes slider
    $('.generic-slick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
      	fade: true,
        arrows: false,
        dots: false,
        mobileFirst: true
    });
  
    // Show/Hide Special Discount banner
    $('.page-layer .middle .quotes').on('afterChange', function(event, slick, currentSlide, nextSlide){
        if(currentSlide === 0){
            $(".page-layer .middle .special").addClass('visible').removeClass('notVisible');
        } else {
            $(".page-layer .middle .special").addClass('notVisible').removeClass('visible');
        }
    });

    /**
     * Sticky Nav
     */
    var navbar = $("#header .topheader");
    var height = navbar.outerHeight();
    $(window).on('scroll', function () {
        if (window.pageYOffset >= height && $(window).width() >= 990) {
            $("body").addClass('stickied');
        } else {
            $("body").removeClass('stickied');
        }
    });

    /**
     * Science Page
     */
    // Jump
    $("#jump .jump").on('click', function(){
        var id = $(this).attr('data-id');
        if(id === '1'){
            $("html, body").animate({scrollTop: $('#blocks').offset().top - 50}, 250);
        } else if(id === '2'){
            $("html, body").animate({scrollTop: $('#brilliance').offset().top - 50}, 500);
        } else if(id === '3'){
            $("html, body").animate({scrollTop: $('#clinical').offset().top - 50}, 750);
        } else {
            $("html, body").animate({scrollTop: $('#publications').offset().top - 50}, 1000);
        }
    });

    /**
     * Collections Page
     * Select category changer
     */
    $(".template-collection .categories-select").on('change', function(){
       var url = $(this).find(":selected").val();
       window.location.href = url;
    });

    $(".description-jump").on('click', function(){
        $("html, body").animate({scrollTop: $('#tab-1').offset().top - 300}, 500);
    });

    /**
     * Close Newsletter
     * Hide for 24 hours
     */
    $(document).on('click', "#mc_embed_signup .close", function(e){
        $(this).parent().parent().parent().fadeOut();
        document.cookie = "newsletter=hide";
       $('body').css('margin-bottom','0px');

    });

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    var newsletter = getCookie("newsletter");
    if(newsletter === 'hide'){
        $("#mc_embed_signup").remove();
    }
});

function numbersonly(myfield, e, dec) {
    var key;
    var keychar;

    if (window.event)
        key = window.event.keyCode;
    else if (e)
        key = e.which;
    else
        return true;
    keychar = String.fromCharCode(key);

    // control keys
    if ((key == null) || (key == 0) || (key == 8) ||
        (key == 9) || (key == 13) || (key == 27))
        return true;
    // numbers
    else if ((("0123456789").indexOf(keychar) > -1))
        return true;
    else
        return false;
}


// lazysizes trigger 
// ============================================
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){ e.target.style.backgroundImage = 'url(' + bg + ')'; }
});


class Campaign_form_driver {
    
    constructor(){
        this.els = null;
        this.params = {key: "campaign"};
        
    } // end of constructor
    
    init(els){
        this.params.value = this.get_campaign_value();
        this.els = els;
        return this.fill_campaign_value();
    } /// end of init function

    fill_campaign_value(){
        var the_items = this.els || null;
        if(null === the_items) return this;
        the_items.forEach(s => s.value = this.params.value);
        return this;
    }

    get_campaign_value(){
        
        var campaign_value = localStorage.getItem(this.params.key),
            query_params = this.parse_query();
            
            if("undefined" !== typeof query_params[this.params.key] && query_params[this.params.key].length > 0){
                campaign_value = query_params[this.params.key];
                localStorage.setItem(this.params.key, campaign_value);
            }
            return campaign_value;

    }// function toget campaign value
    parse_query(){
        var     
            str = window.location.search,
            objURL = {};

        str.replace(
            new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
            function( $0, $1, $2, $3 ){ objURL[ $1 ] = $3; }
        );

        return objURL;
    } // end of parse query

} // end of class Campaign_form_driver




document.addEventListener("DOMContentLoaded", function(){
    lazySizes.init();
    new Campaign_form_driver().init(document.querySelectorAll("#ContactFormAnalyticTrace"));
});
// ====== end of lazysize trigger ==============




